"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _constans = require("../../../../../configuration/constans");

var _FavoriteIconComponent = _interopRequireDefault(require("../../../../PEP-favorite-product/js/FavoriteIconComponent"));

var _utils = require("../../../../../configuration/utils");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductOverviewComponent = function ProductOverviewComponent(_ref) {
  var _getHearingLossSeverr;

  var product = _ref.product,
      dictionary = _ref.dictionary,
      index = _ref.index,
      isAccessoriesList = _ref.isAccessoriesList,
      lazyLoad = _ref.lazyLoad,
      isRouter = _ref.isRouter,
      _ref$selectedFilters = _ref.selectedFilters,
      selectedFilters = _ref$selectedFilters === void 0 ? selectedFilters !== null && selectedFilters !== void 0 ? selectedFilters : [] : _ref$selectedFilters,
      _ref$redirectUrl = _ref.redirectUrl,
      redirectUrl = _ref$redirectUrl === void 0 ? '' : _ref$redirectUrl,
      _ref$isProductGuide = _ref.isProductGuide,
      isProductGuide = _ref$isProductGuide === void 0 ? false : _ref$isProductGuide;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      productName = _useState2[0],
      setproductName = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      displayFirstProductColor = _useState4[0],
      setDisplayFirstProductColor = _useState4[1];

  (0, _react.useEffect)(function () {
    setproductName(product.title);
  }, [product.title]);
  (0, _react.useEffect)(function () {
    if (document.querySelector(".product-list-image-first")) {
      setDisplayFirstProductColor(true);
      setImageWidthFix();
    }
  }, []);

  var getSelectedFilterValues = function getSelectedFilterValues(filters) {
    var resolvedFilters = function resolvedFilters(filter, param) {
      return String(selectedFilters.filter(function (item) {
        return item.dataKey === filter;
      }).map(function (selectedFilter) {
        return selectedFilter[param];
      }).sort());
    };

    var resolvedData = resolvedFilters(filters[0], 'value') || 'none';

    if (filters.length > 1) {
      var filterArr = [];
      filters.forEach(function (filter) {
        if (resolvedFilters(filter, 'dataKey')) {
          filterArr.push(resolvedFilters(filter, 'dataKey')[0].toUpperCase() + resolvedFilters(filter, 'dataKey').slice(1));
        }
      });

      if (filterArr.filter(function (item) {
        return item;
      }).length) {
        resolvedData = String(filterArr.filter(function (item) {
          return item;
        }));
      }
    }

    return resolvedData;
  };

  var setImageWidthFix = function setImageWidthFix() {
    var images = document.querySelectorAll(".product-pep__image img");
    images.forEach(function (image) {
      image.parentElement.classList.add("position-fix");

      image.onload = function () {
        var interval = setInterval(function () {
          if (image.naturalWidth !== image.naturalHeight) {
            clearInterval(interval);
            image.parentElement.classList.add("width-fix");
          }
        }, 100);
      };
    });
  };

  var productHeroThumbnailUrlCallback = (0, _react.useCallback)(function () {
    return (0, _utils.resolveThumbnailImage)(product === null || product === void 0 ? void 0 : product.images[0], _constans.fastlyCompressionQuery.productOverview);
  }, [product, _constans.fastlyCompressionQuery, _utils.resolveThumbnailImage]);
  var productHeroImageCallback = (0, _react.useCallback)(function () {
    return (0, _utils.resolveImage)(product === null || product === void 0 ? void 0 : product.images[0], _constans.fastlyCompressionQuery.productOverview);
  }, [product, _constans.fastlyCompressionQuery, _utils.resolveImage]);
  var variantHeroThumbnailUrlCallback = (0, _react.useCallback)(function () {
    var _product$items$;

    return product !== null && product !== void 0 && product.items && product !== null && product !== void 0 && product.items.length ? (0, _utils.resolveThumbnailImage)(product === null || product === void 0 ? void 0 : (_product$items$ = product.items[0]) === null || _product$items$ === void 0 ? void 0 : _product$items$.images[0], _constans.fastlyCompressionQuery.productOverview) : productHeroThumbnailUrl;
  }, [product, _constans.fastlyCompressionQuery, _utils.resolveThumbnailImage]); // TODO: all these logic rergarding images shouldb be simplyfy when we complete with success CDN url experiment (image compresion)

  var productHeroThumbnailUrl = productHeroThumbnailUrlCallback();
  var productHeroImageUrl = productHeroImageCallback();
  var variantHeroImageUrlCallback = (0, _react.useCallback)(function () {
    var _product$items$2, _product$items$3, _product$items$4;

    return product !== null && product !== void 0 && product.items && product !== null && product !== void 0 && product.items.length && product !== null && product !== void 0 && (_product$items$2 = product.items[0]) !== null && _product$items$2 !== void 0 && _product$items$2.images && product !== null && product !== void 0 && (_product$items$3 = product.items[0]) !== null && _product$items$3 !== void 0 && _product$items$3.images.length ? (0, _utils.resolveImage)(product === null || product === void 0 ? void 0 : (_product$items$4 = product.items[0]) === null || _product$items$4 === void 0 ? void 0 : _product$items$4.images[0], _constans.fastlyCompressionQuery.productOverview) : productHeroImageUrl;
  }, [product, _constans.fastlyCompressionQuery, _utils.resolveImage, productHeroImageUrl]); //need check if exists because we have some products in API which exists without any variants

  var variantHeroThumbnailUrl = variantHeroThumbnailUrlCallback();
  var variantHeroImageUrl = variantHeroImageUrlCallback();
  var displayFirstVariant = Boolean(isAccessoriesList || document.body.classList.contains("normal-image-active") || displayFirstProductColor);
  var desktopImageCallback = (0, _react.useCallback)(function () {
    return displayFirstVariant ? displayFirstProductColor ? variantHeroImageUrl : productHeroThumbnailUrl : displayFirstProductColor ? variantHeroThumbnailUrl : productHeroThumbnailUrl;
  }, [product, _constans.fastlyCompressionQuery, _utils.resolveImage, productHeroImageUrl, displayFirstProductColor]);
  var desktopImage = desktopImageCallback();
  var mobileImage = displayFirstVariant ? variantHeroImageUrl : variantHeroThumbnailUrl;

  var renderImage = function renderImage() {
    return window.innerWidth > 800 ? /*#__PURE__*/_react["default"].createElement("img", {
      src: desktopImage,
      alt: product.title,
      height: "230",
      width: "230"
    }) : /*#__PURE__*/_react["default"].createElement("img", {
      src: index < 7 && lazyLoad || !lazyLoad ? mobileImage : '',
      alt: (product === null || product === void 0 ? void 0 : product.title) || '',
      height: "150",
      width: "150"
    });
  };

  var resolveCustomImageClass = function resolveCustomImageClass(isCustomClass) {
    return isCustomClass ? 'small-image' : '';
  };

  var hearingLossSeverity = ((_getHearingLossSeverr = (0, _utils.getHearingLossSeverrity)(product.hearingLossSeverityFilter, product.hearingLossSeverity)) === null || _getHearingLossSeverr === void 0 ? void 0 : _getHearingLossSeverr.join(", ")) || '';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isRouter ? /*#__PURE__*/_react["default"].createElement("a", {
    key: product.productId,
    href: dictionary.productDetailsPath + String(product.productId) + (isAccessoriesList ? _constans.initialState.accessoryParametr : "") + (redirectUrl ? '&redirectUrl=' + redirectUrl : ''),
    className: "product-pep off-anchor-style fade-in animated",
    tabIndex: 5,
    style: {
      order: index
    },
    onClick: function onClick() {
      (0, _utils.sendDataLayerEvent)(document.querySelector(".related-products") ? "Related product card" : "Product card", "".concat(productName, " ").concat(product.subtitle || ""));
      isProductGuide ? (0, _utils.sendGA4DataLayerEvent)('genericGAEvent', 'product_click', "".concat(productName, " ").concat(product.subtitle), "product_guide", '', product.productId) : (0, _utils.sendCustomGA4DataLayerEvent)("".concat(productName, " ").concat(product.subtitle), 'product_category', getSelectedFilterValues(['bteOrIte']), getSelectedFilterValues(['hearingLossSeverityFilter']), getSelectedFilterValues(['bluetooth', 'rechargeability', 'telecoil']), getSelectedFilterValues(['designedForFilter']), product.productId);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__title"
  }, productName && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__title__name",
    dangerouslySetInnerHTML: {
      __html: productName
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__title__style"
  }, product.subtitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__favorite"
  }, /*#__PURE__*/_react["default"].createElement(_FavoriteIconComponent["default"], {
    product: product,
    dictionary: dictionary
  }))), product.images && product.images.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__image ".concat(resolveCustomImageClass(product.bluetoothExcludesTelecoil))
  }, renderImage()), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__text"
  }, product.hearingLossSeverity && product.hearingLossSeverity.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__hearing-loss-severity"
  }, dictionary["Hearing Loss"], ":", " ", hearingLossSeverity), product.bluetoothExcludesTelecoil && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__bluetooth-vs-telecoil"
  }, dictionary["Bluetooth vs telecoil"]), (product.batterySizes && product.batterySizes.length > 0 || product.rechargeability) && product.batterySizes[0] != null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__battery"
  }, dictionary["Battery Type"], ":", " ", product.rechargeability ? dictionary["Rechargeable"] : product.batterySizes.join(", ")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__container-link"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__icons"
  }, (product === null || product === void 0 ? void 0 : product.items) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, product === null || product === void 0 ? void 0 : product.items.slice(0, 9).map(function (item, index) {
    return item.colorName && item.colorCode && /*#__PURE__*/_react["default"].createElement("span", {
      className: "product-pep__icons__circle",
      style: {
        background: (0, _utils.dotsBackgroundColor)(item)
      },
      key: index
    });
  }), product.items.length > 9 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "..."))), isAccessoriesList && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-link"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fake-link like-a"
  }, dictionary.readMore, " "), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pep-arrow"
  }, "\uEB4B"))))) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    key: product.productId,
    to: dictionary.productDetailsPath + String(product.productId) + (isAccessoriesList ? _constans.initialState.accessoryParametr : ""),
    className: "product-pep off-anchor-style fade-in animated",
    tabIndex: 5,
    style: {
      order: index
    },
    onClick: function onClick(e) {
      (0, _utils.sendDataLayerEvent)(document.querySelector(".related-products") ? "Related product card" : "Product card", "".concat(productName, " ").concat(product.subtitle));
      isProductGuide ? (0, _utils.sendGA4DataLayerEvent)('genericGAEvent', 'product_click', "".concat(productName, " ").concat(product.subtitle), "product_guide", '', product.productId) : (0, _utils.sendCustomGA4DataLayerEvent)("".concat(productName, " ").concat(product.subtitle), 'product_category', getSelectedFilterValues(['bteOrIte']), getSelectedFilterValues(['hearingLossSeverityFilter']), getSelectedFilterValues(['bluetooth', 'rechargeability', 'telecoil']), getSelectedFilterValues(['designedForFilter']), product.productId);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__title"
  }, productName && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__title__name",
    dangerouslySetInnerHTML: {
      __html: productName
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__title__style"
  }, product.subtitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__header__favorite"
  }, /*#__PURE__*/_react["default"].createElement(_FavoriteIconComponent["default"], {
    product: product,
    dictionary: dictionary
  }))), product.images && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__image ".concat(isAccessoriesList ? 'accessory' : '', " ").concat(resolveCustomImageClass(product.bluetoothExcludesTelecoil))
  }, renderImage()), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__text"
  }, product.hearingLossSeverity && product.hearingLossSeverity.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__hearing-loss-severity"
  }, dictionary["Hearing Loss"], ":", " ", hearingLossSeverity), product.bluetoothExcludesTelecoil && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__bluetooth-vs-telecoil"
  }, dictionary["Bluetooth vs telecoil"]), (product.batterySizes && product.batterySizes.length > 0 || product.rechargeability) && product.batterySizes[0] != null && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__battery"
  }, dictionary["Battery Type"], ":", " ", product.rechargeability ? dictionary["Rechargeable"] : product.batterySizes.join(", ")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__container-link"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-pep__icons"
  }, (product === null || product === void 0 ? void 0 : product.items) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, product.items.slice(0, 9).map(function (item, index) {
    return item.colorName && item.colorCode && /*#__PURE__*/_react["default"].createElement("span", {
      className: "product-pep__icons__circle",
      style: {
        background: (0, _utils.dotsBackgroundColor)(item)
      },
      key: index
    });
  }), (product === null || product === void 0 ? void 0 : product.items.length) > 9 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "..."))), isAccessoriesList && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-link"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fake-link like-a"
  }, dictionary.readMore, " "), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pep-arrow"
  }, "\uEB4B"))))));
};

var _default = ProductOverviewComponent;
exports["default"] = _default;